import React, { useState } from 'react';
import colors from '../../utils/colors';
import typography from '../../utils/typography';
import { CheckIcon, CloseIcon } from '../../utils/icons';
import MediumButton from './MediumButton';

const NewWorkspaceCell = ({ onConfirm, onCancel }) => {
  const [title, setTitle] = useState('');

  const handleConfirm = () => {
    const finalTitle = title.trim() || 'Untitled';
    onConfirm?.(finalTitle);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleConfirm();
    } else if (e.key === 'Escape') {
      onCancel?.();
    }
  };

  return (
    <div className="flex items-center justify-between w-full">
      <div className="flex gap-3 items-center flex-1 min-w-0">
        <div
          className="w-[60px] h-[50px] rounded-lg flex-shrink-0"
          style={{ backgroundColor: colors.bg.fog.thin }}
        />
        <div className="flex flex-col gap-1 py-1.5 flex-1 min-w-0">
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Untitled"
            autoFocus
            className="bg-transparent border-none outline-none w-full"
            style={{
              ...typography.small.title,
              color: title ? colors.text.primary : colors.text.inactive
            }}
          />
          <div className="flex gap-1 text-xs" style={{ color: colors.text.secondary }}>
            <span>0 songs</span>
            <span>•</span>
            <span>Just now</span>
          </div>
        </div>
      </div>
      <div className="flex gap-4 items-center">
        <MediumButton
          variant="secondary"
          text="Confirm"
          leftIcon={<CheckIcon />}
          onClick={handleConfirm}
        />
        <button
          onClick={onCancel}
          className="w-6 h-6 flex items-center justify-center opacity-90 hover:opacity-100 transition-opacity"
          style={{ color: colors.text.inactive }}
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};

export default NewWorkspaceCell;
